import React, { useState } from 'react';
import { Info } from 'lucide-react';
import EscolherAnexo from '../../EscolherAnexo';
// Vídeo do procedimento embutido na tela (componente compartilhado).
// ⚠️ O `apiBase` é o proxy do MÓDULO dono do vídeo — cada módulo tem o seu.
import VideoProcedimento from '../../VideoProcedimento';

// Proxy de vídeo do módulo Financeiro (catálogo em dtbVideoProcedimento).
const API_VIDEOS = '/api/financeiro/videos';
// Teal do Financeiro (docs/ARQUITETURA.md › Paleta dos módulos) — o mesmo tom do
// título desta tela.
const COR_FINANCEIRO = '#0f766e';

const FinanceiroEstorno = () => {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    // Perfis presos à própria loja: a loja do estorno vem travada no valor do
    // usuário (não escolhem outra). Gerente / Gerente Plantão e o Coordenador de
    // Qualidade (que solicita estorno apenas para a própria loja).
    const lojaTravada = user?.perfil === 'Gerente'
        || user?.perfil === 'Gerente Plantao'
        || user?.perfil === 'Coordenador de Qualidade';
    
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 1024);

    // Estados necessários para o formulário
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [lojas] = useState(['ANV', 'BVV', 'FER', 'GTV', 'MAL', 'MOX', 'PCI', 'PCS', 'RDP', 'SED', 'SVV', 'VEL', 'VSH']);
    
    const hoje = new Date();
    const dataAtual = String(hoje.getDate()).padStart(2, '0') + '/' + 
                      String(hoje.getMonth() + 1).padStart(2, '0') + '/' + 
                      hoje.getFullYear();


    const criarFormInicial = () => ({
        restaurante: lojaTravada ? user.loja : '',
        dataSolicitacao: dataAtual,
        nomeCliente: '', telefoneCliente: '', emailCliente: '',
        numeroCartao: '', bandeiraCartao: '', tipoCartao: '', chavePix: '',
        valorVenda: '', valorEstorno: '', dataOcorrencia: '',
        descricaoOcorrencia: '', comprovante: null
    });

    const [formData, setFormData] = useState(criarFormInicial);

    const bandeirasSemTipo = ['Pix', 'Alelo', 'Ticket', 'Sodexo', 'VR Beneficios'];
    const necessitaTipoCartao = !bandeirasSemTipo.includes(formData.bandeiraCartao);
    const isPix = formData.bandeiraCartao === 'Pix';

    const handleFormChange = (e) => {
        const { name, value } = e.target;

        if (name === 'bandeiraCartao' && bandeirasSemTipo.includes(value)) {
            setFormData(prev => ({ ...prev, [name]: value, tipoCartao: '' }));
            return;
        }

        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);

        const formDataToSend = new FormData();
        Object.keys(formData).forEach(key => {
            if (formData[key]) formDataToSend.append(key, formData[key]);
        });

        try {
            const token = localStorage.getItem('token') || localStorage.getItem('authToken');
            const res = await fetch('/api/estorno/submit', {
                method: 'POST',
                headers: { 'Authorization': `Bearer ${token}` },
                body: formDataToSend
            });
            if (res.ok) {
                alert('Estorno enviado com sucesso!');
                setFormData(criarFormInicial());
            } else {
                alert('Erro ao enviar.');
            }
        } catch (err) { alert('Erro de conexão.'); }
        finally { setIsSubmitting(false); }
    };

    const camposObrigatorios = [
      'restaurante', 'nomeCliente', 'telefoneCliente', 'emailCliente',
      'bandeiraCartao', 'valorVenda', 'valorEstorno',
      'dataOcorrencia', 'descricaoOcorrencia',
      ...(isPix ? ['chavePix'] : ['numeroCartao'])
    ];

    return (
        <div style={{ backgroundColor: '#fff', padding: '30px', borderRadius: '16px', border: '1px solid #e2e8f0' }}>
            <div style={{ textAlign: 'center', marginBottom: '30px' }}>
                <h1 style={{ fontSize: '24px', fontWeight: '800', color: '#0f766e', marginBottom: '10px' }}>Solicitação de Estorno</h1>
                <p style={{ color: '#64748b' }}>Preencha os dados abaixo para solicitar o estorno financeiro.</p>
                {/* O "como fazer" ao lado do próprio formulário — quem tem dúvida do
                    procedimento resolve aqui, sem sair da tela. Some sozinho se o
                    vídeo não estiver no ar (o componente não desenha nada com 404). */}
                <div style={{ marginTop: '14px' }}>
                    <VideoProcedimento
                        apiBase={API_VIDEOS}
                        chave="estorno-venda"
                        cor={COR_FINANCEIRO}
                    />
                </div>
            </div>

            <div style={{ backgroundColor: '#f0fdfa', borderLeft: '4px solid #0d9488', padding: '16px 20px', borderRadius: '8px', marginBottom: '30px' }}>
                <h4 style={{ display: 'flex', alignItems: 'center', gap: '8px', color: '#0f766e', fontSize: '15px', fontWeight: '700', margin: '0 0 10px 0' }}>
                    <Info size={18} /> Importante
                </h4>
                <p style={{ color: '#115e59', fontSize: '14px', lineHeight: '1.6', margin: 0 }}>
                    Lembre-se de anexar o cupom de venda no sistema. Caso seja identificado duplicidade no pagamento, em até 5 dias úteis, solicitaremos o estorno.
                </p>
            </div>

            <form onSubmit={handleSubmit} style={{ display: 'grid', gap: '20px' }}>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
                    <div>
                        <label>Restaurante *</label>
                        <select name="restaurante" value={formData.restaurante} onChange={handleFormChange} disabled={lojaTravada} style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #cbd5e1' }} required>
                            <option value="">Selecione o Restaurante</option>
                            {lojas.map(l => <option key={l} value={l}>{l}</option>)}
                        </select>
                    </div>
                    <div>
                        <label>Data da Solicitação</label>
                        <input type="text" value={formData.dataSolicitacao} readOnly style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #cbd5e1', backgroundColor: '#f1f5f9' }} />
                    </div>
                </div>

                <div>
                    <label>Nome do Cliente *</label>
                    <input type="text" name="nomeCliente" value={formData.nomeCliente} onChange={handleFormChange} style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #cbd5e1' }} required />
                </div>

                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
                    <div>
                        <label>Telefone *</label>
                        <input type="tel" name="telefoneCliente" value={formData.telefoneCliente} onChange={handleFormChange} style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #cbd5e1' }} required />
                    </div>
                    <div>
                        <label>E-mail *</label>
                        <input type="email" name="emailCliente" value={formData.emailCliente} onChange={handleFormChange} style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #cbd5e1' }} required />
                    </div>
                </div>

                <hr style={{ borderTop: '1px solid #e2e8f0' }} />

                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '20px' }}>
                    <div>
                        {isPix ? (
                            <>
                                <label>Chave PIX do Cliente *</label>
                                <input type="text" name="chavePix" value={formData.chavePix} onChange={handleFormChange} placeholder="CPF, e-mail, telefone ou chave aleatória" style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #cbd5e1' }} required />
                            </>
                        ) : (
                            <>
                                <label>Nº Cartão (Os últimos 4 dígitos) *</label>
                                <input type="text" name="numeroCartao" value={formData.numeroCartao} onChange={handleFormChange} style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #cbd5e1' }} required />
                            </>
                        )}
                    </div>
                    <div>
                        <label>Forma de Pagamento *</label>
                        <select id="bandeiraCartao" name="bandeiraCartao" value={formData.bandeiraCartao} onChange={handleFormChange} className="form-input" required>
                            <option value="">Selecione</option>
                            <option value="American Express">American Express</option>
                            <option value="Alelo">Alelo</option>
                            <option value="Banescard">Banescard</option>
                            <option value="Elo">Elo</option>
                            <option value="Mastercard">Mastercard</option>
                            <option value="Pix">Pix</option>
                            <option value="Sodexo">Sodexo</option>
                            <option value="Ticket">Ticket</option>
                            <option value="Visa">Visa</option>
                            <option value="VR Beneficios">VR Beneficios</option>
                            
                            
                        </select>
                    </div>
                    <div className="form-group" style={{ margin: 0 }}>
                    <label htmlFor="tipoCartao" className="label">Débito / Crédito {necessitaTipoCartao && '*'}</label>
                    <select 
                      id="tipoCartao" 
                      name="tipoCartao" 
                      value={formData.tipoCartao} 
                      onChange={handleFormChange} 
                      className="form-input" 
                      required={necessitaTipoCartao}
                      disabled={!necessitaTipoCartao}
                      style={{ 
                        backgroundColor: !necessitaTipoCartao ? '#f1f5f9' : '#fff',
                        cursor: !necessitaTipoCartao ? 'not-allowed' : 'auto'
                      }}
                    >
                      <option value="">Selecione</option>
                      <option value="Débito">Débito</option>
                      <option value="Crédito">Crédito</option>
                    </select>
                  </div>
                </div>

                <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr 1fr', gap: '20px', marginBottom: '20px' }}>
                  <div className="form-group" style={{ margin: 0 }}>
                    <label htmlFor="valorVenda" className="label">Valor de Venda (R$) *</label>
                    <input id="valorVenda" type="number" step="0.01" name="valorVenda" value={formData.valorVenda} onChange={handleFormChange} className="form-input" required placeholder="0.00" />
                  </div>
                  <div className="form-group" style={{ margin: 0 }}>
                    <label htmlFor="valorEstorno" className="label">Valor Estorno (R$) *</label>
                    <input id="valorEstorno" type="number" step="0.01" name="valorEstorno" value={formData.valorEstorno} onChange={handleFormChange} className="form-input" required placeholder="0.00" />
                  </div>
                  <div className="form-group" style={{ margin: 0 }}>
                    <label htmlFor="dataOcorrencia" className="label">Data da Venda *</label>
                    <input id="dataOcorrencia" type="date" name="dataOcorrencia" value={formData.dataOcorrencia} onChange={handleFormChange} className="form-input" required />
                  </div>
                </div>

                <div className="form-group" style={{ width: '100%' }}>
                  <label htmlFor="descricaoOcorrencia" className="label">Descrição da Ocorrência *</label>
                <textarea name="descricaoOcorrencia" value={formData.descricaoOcorrencia} onChange={handleFormChange} placeholder="Descrição da Ocorrência" style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #cbd5e1', minHeight: '100px' }} required />
                </div>

                <div>
                    {/* ⚠️ O input não tinha `accept` nenhum — o Android abria só o
                        seletor de Documentos (sem câmera) e ainda deixava escolher
                        tipo que o servidor recusa. O `accept` abaixo espelha o
                        TIPOS_PERMITIDOS_EST do server-estornocartao.js. */}
                    <label>Anexar Cupom Fiscal</label>
                    <div style={{ marginTop: 8 }}>
                        <EscolherAnexo
                            accept="image/jpeg,image/png,image/webp,application/pdf"
                            cor="#0d9488"
                            nome={formData.comprovante ? formData.comprovante.name : ''}
                            onArquivo={(file) => setFormData(prev => ({ ...prev, comprovante: file }))}
                        />
                    </div>
                </div>

                <button type="submit" disabled={isSubmitting} style={{ padding: '14px', backgroundColor: '#0d9488', color: '#fff', border: 'none', borderRadius: '8px', fontWeight: '700', cursor: 'pointer' }}>
                    {isSubmitting ? 'Enviando...' : 'Finalizar Solicitação'}
                </button>
            </form>
        </div>
    );
};

export default FinanceiroEstorno;